import React from 'react'
import { createPortal } from 'react-dom'
import { TypeModal } from '../../context/notification/type-modal'
import { itemType } from '../../context/notification/hooks'
import { withReference } from '../error/error-notice'

// A web viewer launch that didn't open (useViewerLaunch's `failure`), as the
// admin's shared error modal shows an API error (context/notification), with
// the request's reference for support. For launches started from a menu --
// the staff sidebar's Web viewer, a course's "Launch" on its page's header
// and in its card's ⋮ -- which have nowhere to show a line of their own.
// In a portal: the phone drawer closes on the click and must not take the
// error with it, and some callers sit outside the page's NotificationProvider.
export const ViewerLaunchFailure = ({ failure, onClose }) =>
  createPortal(
    <div role="alertdialog" aria-modal="true" aria-label="Web viewer">
      <TypeModal state={[{ id: 'web-viewer', data: { type: itemType.ERROR, text: withReference(failure.message, failure.error) } }]} onClose={onClose} />
    </div>,
    document.body
  )
